module.exports = "<app-post-feed *ngFor=\"let p of posts\" [post]=\"p\"></app-post-feed>\n"